import { render, staticRenderFns } from "./StoreFields.vue?vue&type=template&id=965f5b4e&scoped=true"
import script from "./StoreFields.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreFields.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./StoreFields.vue?vue&type=style&index=0&id=965f5b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965f5b4e",
  null
  
)

export default component.exports